import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "We Answer. Day or Night.",
    body: "A dead furnace in January or a dead AC in July can't wait until Monday. When you call TN HVAC, a real local tech picks up — 24 hours a day, 7 days a week, holidays included.",
  },
  {
    num: "02",
    title: "Fixed Right The First Time.",
    body: "No band-aid repairs, no upsell games. We diagnose the real problem, show you the options in plain English, and stand behind every job we touch.",
  },
  {
    num: "03",
    title: "Local. Licensed. Accountable.",
    body: "We're your neighbors in East Tennessee — not a call center three states away. Licensed, fully insured, and rated 4.8 stars by the homeowners we serve.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="about"
      className="relative py-24 md:py-32 border-b border-white/10"
      data-testid="manifesto-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#FF6B00] mb-6"
        >
          The TN HVAC Standard
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight max-w-3xl mb-20 md:mb-28"
        >
          Comfort isn't a luxury.{" "}
          <span className="text-zinc-500">It's a promise.</span>
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {chapters.map((ch, i) => (
            <motion.article
              key={ch.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#050505] p-8 md:p-12 group hover:bg-[#121212] transition-colors duration-500"
              data-testid={`manifesto-chapter-${ch.num}`}
            >
              <span className="font-display font-bold text-6xl md:text-7xl text-outline-orange group-hover:text-[#FF6B00] group-hover:[-webkit-text-stroke:0] transition-all duration-500 block mb-8">
                {ch.num}
              </span>
              <h3 className="font-display font-semibold uppercase tracking-tight text-2xl md:text-3xl mb-4">
                {ch.title}
              </h3>
              <p className="text-zinc-400 text-base leading-relaxed">{ch.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
